export const REQUEST_GET_TEMPLATE = 'template/REQUEST_GET_TEMPLATE';
export const RECEIVED_TEMPLATE = 'template/RECEIVED_TEMPLATE';
export const REQUEST_GET_TEMPLATE_LIST = 'template/REQUEST_GET_TEMPLATE_LIST';
export const RECEIVED_TEMPLATE_LIST = 'template/RECEIVED_TEMPLATE_LIST';
export const EMPTY_TEMPLATE_LIST = 'template/EMPTY_TEMPLATE_LIST';
export const REQUEST_GET_SPECIFIC_TEMPLATE = 'template/REQUEST_GET_SPECIFIC_TEMPLATE';
export const RECEIVED_SPECIFIC_TEMPLATE = 'template/RECEIVED_SPECIFIC_TEMPLATE';
export const REQUEST_UPDATE_TEMPLATE = 'template/REQUEST_UPDATE_TEMPLATE';
export const UPDATED_TEMPLATE_SUCCESSFULLY = 'template/UPDATED_TEMPLATE_SUCCESSFULLY';
export const RECEIVED_ERROR = 'template/RECEIVED_ERROR';
export const EMPTY_SPECIFIC_TEMPLATE = 'template/EMPTY_SPECIFIC_TEMPLATE';
export const RECEIVED_WEB_TO_LEAD_DATA = 'template/RECEIVED_WEB_TO_LEAD_DATA';
